import React, { forwardRef } from 'react'
import classNames from 'classnames'
import styles from './Toggle.module.css'
import { default as generalStyle } from '../Theme/GeneralTheme.module.css'

function Toggle_({
  ...props
}, ref) {

  const { className, ...rest } = props;
  const childrenClassNames = classNames([
    generalStyle.general_style,
    styles.switch,
    props.disabled && styles.disabled,
  ], className)

  return (
    <label
      className={childrenClassNames}
    >
      <input
        type="checkbox"
        ref={ref}
        {...rest}
      />
      <span
        className={classNames([
          styles.slider,
          styles.round
        ])}
      />
    </label>
  )
}

const Toggle = forwardRef(Toggle_);


export { Toggle }
